import { CultureCode, CurrencyCode, LanguageCode, constructLanguageCodeIso15897 } from '@shared/hooks/useGeoLocale';
import type { SupportedCurrency } from '@shared/utils/currency';

/**
 * Currencies specifically supported for print functionality in the card app.
 * This is a subset of SUPPORTED_CURRENCIES that are available for print products.
 */
export const PRINT_SUPPORTED_CURRENCIES: ReadonlyArray<SupportedCurrency> = [
  {
    code: CurrencyCode.USD,
    culture: CultureCode.US,
    language: LanguageCode.en,
    locale: constructLanguageCodeIso15897(LanguageCode.en, CultureCode.US),
    flag: '🇺🇸',
  },
  {
    code: CurrencyCode.EUR,
    culture: CultureCode.DE,
    language: LanguageCode.de,
    locale: constructLanguageCodeIso15897(LanguageCode.de, CultureCode.DE),
    flag: '🇩🇪',
  },
  {
    code: CurrencyCode.GBP,
    culture: CultureCode.GB,
    language: LanguageCode.en,
    locale: constructLanguageCodeIso15897(LanguageCode.en, CultureCode.GB),
    flag: '🇬🇧',
  },
  {
    code: CurrencyCode.CAD,
    culture: CultureCode.CA,
    language: LanguageCode.en,
    locale: constructLanguageCodeIso15897(LanguageCode.en, CultureCode.CA),
    flag: '🇨🇦',
  },
  {
    code: CurrencyCode.AUD,
    culture: CultureCode.AU,
    language: LanguageCode.en,
    locale: constructLanguageCodeIso15897(LanguageCode.en, CultureCode.AU),
    flag: '🇦🇺',
  },
  {
    code: CurrencyCode.NZD,
    culture: CultureCode.NZ,
    language: LanguageCode.en,
    locale: constructLanguageCodeIso15897(LanguageCode.en, CultureCode.NZ),
    flag: '🇳🇿',
  },
  {
    code: CurrencyCode.SGD,
    culture: CultureCode.SG,
    language: LanguageCode.en,
    locale: constructLanguageCodeIso15897(LanguageCode.en, CultureCode.SG),
    flag: '🇸🇬',
  },
];
